module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921094149_T.a779a8ee.jpg";